import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import {
  installFirebaseAppCheckDebugToken,
  resolveFirebaseAppCheckConfig,
} from './firebaseAppCheckConfig';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCu0O0Zo8omI9af_ZFYgGU7XMCzv5SEOT8",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tribechallengetracker.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID || "tribechallengetracker",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tribechallengetracker.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1045104267271",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID || "1:1045104267271:web:0460d2ff12c04a37f61aa2",
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

const appCheckConfig = resolveFirebaseAppCheckConfig(process.env);
installFirebaseAppCheckDebugToken(
  typeof globalThis === 'undefined' ? null : globalThis,
  appCheckConfig.debugToken,
);
export const appCheck = appCheckConfig.enabled
  ? initializeAppCheck(firebaseApp, {
    isTokenAutoRefreshEnabled: true,
    provider: new ReCaptchaEnterpriseProvider(appCheckConfig.siteKey),
  })
  : null;
export const firebaseAppCheckReady = appCheck !== null;

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
